import { QueryView } from '@ui/utils/async-view/QueryView';
import { useStationCtx } from '../../../../core/containers/StationCtx';
import { RecordCtxProvider } from '../../../../core/context/record-ctx';
import { useStationsFinder } from '../../../../core/stations/hooks/useStations';
import { useFragmentQuery } from '../../hooks/useFragment';
import { useParams, useRouteMatch } from 'react-router-dom';
import { FragmentsViewScreenP } from './ScreenP';

export function FragmentsViewPage() {
  const { fragmentId } = useParams<{ fragmentId: string }>();
  const { path } = useRouteMatch();
  const finder = useStationsFinder();
  const stationFromContext = useStationCtx({ innerThrowIfMissingProvider: false });

  return (
    <QueryView query={useFragmentQuery(fragmentId!)}>
      {(fragment) => {
        const stationToUse = stationFromContext ?? finder(fragment.stationId);

        if (!stationToUse) {
          throw new Error(`Station with id ${fragment.stationId} not found in state!`);
        }

        return (
          <RecordCtxProvider value={fragment}>
            <FragmentsViewScreenP
              path={path}
              data={{
                fragment,
                station: stationToUse,
              }}
            />
          </RecordCtxProvider>
        );
      }}
    </QueryView>
  );
}
